
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductBillingItemsDialog extends Serenity.EntityDialog<CartProductBillingItemsRow, any> {
        protected getFormKey() { return CartProductBillingItemsForm.formKey; }
        protected getIdProperty() { return CartProductBillingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return CartProductBillingItemsRow.localTextPrefix; }
        protected getService() { return CartProductBillingItemsService.baseUrl; }
        protected getDeletePermission() { return CartProductBillingItemsRow.deletePermission; }
        protected getInsertPermission() { return CartProductBillingItemsRow.insertPermission; }
        protected getUpdatePermission() { return CartProductBillingItemsRow.updatePermission; }

        protected form = new CartProductBillingItemsForm(this.idPrefix);

    }
}